import React from 'react';

const CaretDownIcon = ({ className = "" }) => (
  <i
    className={`fa fa-caret-down ${className}`}
  />
);

export default CaretDownIcon;
